module.exports = __webpack_public_path__ + "static/assets/76024aad6524bdf0e8d438f4d024e581.png";